<template>
  <button
    class="border uppercase duration-200 " :class="classes"
  >
    {{ text }}
    <div :class="iconSize">
      <slot name="icon">
      </slot>
    </div>
  </button>
</template>

<script>
export default {
  data() {
    return {
      paddingClass: {
        thick: 'py-3 px-4',
        padded: 'py-1 px-2',
        squared: 'p-2',
        none: 'p-0',
      },
      cornerClass: {
        rounded: 'rounded',
        squared: 'rounded-none',
        circular: 'rounded-full',
      },
      borderClass: {
        none: 'border-none',
        slim: 'border',
        thick: 'border-2',
      },
      caseClass: {
        uppercase: 'uppercase',
        lowercase: 'lowercase',
        capitalize: 'capitalize',
      },
      widthClass: {
        full: 'w-full',
        fit: 'w-fit',
      },
      textClasses: {
        big: 'text-2xl font-light',
        medium: 'text-base font-semibold',
        little: 'text-sm font-medium',
        very_little: 'text-xs font-medium',
      },
    };
  },
  props: {
    corners: {
      type: String,
      default: 'squared',
    },
    padding: {
      type: String,
      default: 'padded',
    },
    borders: {
      type: String,
      default: 'thin',
    },
    fontCase: {
      type: String,
      default: 'uppercase',
    },
    width: {
      type: String,
      default: 'fit',
    },
    fontSize: {
      type: String,
      default: 'text-sm 2xl:text-base',
    },
    elementsColor: {
      type: String,
      // eslint-disable-next-line max-len
      default: 'border-lh_gold dark:border-white text-lh_gold dark:text-white hover:bg-lh_gold hover:text-white font-semibold',
    },
    disabledClasses: {
      type: String,
      // eslint-disable-next-line max-len
      default: 'dark:disabled:hover:text-gray-300 disabled:border-gray-300 disabled:text-gray-300 disabled:bg-gray-100 dark:disabled:bg-slate-500 dark:disabled:text-gray-300',
    },
    textSize: {
      type: String,
      default: 'little',
    },
    text: {
      type: String,
    },
    iconSize: {
      type: String,
    },
  },
  computed: {
    classes() {
      // eslint-disable-next-line max-len
      return `${this.cornerClass[this.corners]} ${this.borderClass[this.borders]} ${this.caseClass[this.fontCase]} ${this.widthClass[this.width]} ${this.paddingClass[this.padding]} ${this.elementsColor} ${this.disabledClasses} ${this.textClasses[this.textSize]}`;
    },
  },
};
</script>
